import React from 'react';
import { Box, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface IStarMarkProps {
  label: string;
  color: string;
}

export const StarMark: React.FC<IStarMarkProps> = ({ label, color }) => (
  <Tooltip title={label} placement="top">
    <Box
      component="span"
      role="img"
      aria-label={label}
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        padding: '0.125rem',
        borderRadius: '0.25rem',
        color,
      }}
    >
      <StarIcon sx={{ fontSize: '1rem' }} />
    </Box>
  </Tooltip>
);
